export enum SourcingStatusId {
  POTENTIAL_VENDOR_IDENTIFIED = 1,
  NO_VENDOR_FOUND = 2,
  DRAW_FROM_SML = 3,
  PRICE_AGREEMENT_AVAILABLE = 4,
}

export interface SourcingStatusOption {
  id?: SourcingStatusId;
  name: string;
}

export const SourcingStatusOptions: Readonly<SourcingStatusOption[]> =
  Object.freeze([
    {
      id: undefined,
      name: '',
    },
    {
      id: SourcingStatusId.POTENTIAL_VENDOR_IDENTIFIED,
      name: 'Potential vendor identified',
    },
    {
      id: SourcingStatusId.NO_VENDOR_FOUND,
      name: 'No vendor found',
    },
    {
      id: SourcingStatusId.DRAW_FROM_SML,
      name: 'Draw from SML',
    },
    {
      id: SourcingStatusId.PRICE_AGREEMENT_AVAILABLE,
      name: 'Price agreement available',
    },
  ]);
